import React, { FunctionComponent } from 'react';
import { sanitize } from 'dompurify';

export const SafeHtml: FunctionComponent<any> = ({ children, Container = 'div', ...props }) => {
  const config = { };
  // TODO: maybe add configuration https://github.com/cure53/DOMPurify#can-i-configure-dompurify
  return <Container {...props} dangerouslySetInnerHTML={{ __html: sanitize(children, config) }} />;
};
